export const PARTNER_ROW_COMPONENTS = {
    PartnerRowAlpha: 'PartnerRowAlpha',
    PartnerRowBeta: 'PartnerRowBeta',
    PartnerRowGamma: 'PartnerRowGamma',
    PartnerRowDelta: 'PartnerRowDelta',
    PartnerRowEpsilon: 'PartnerRowEpsilon',
    PartnerRowZeta: 'PartnerRowZeta',
    PartnerRowEta: 'PartnerRowEta',
};
